
import * as d3 from "d3";

const BAR_HEIGHT = 1.5;

class Graph {

	constructor (container, data, title) {

		this.container = d3.select(container);

		let width = parseInt(this.container.style("width").replace("px", ""));
		let height = parseInt(this.container.style("height").replace("px", ""));
    
		this.data = data;
        
		this.margin = {
			top: 20,
			bottom: 5,
			left: 140,
			right: 35
		};
    
		this.width = width - this.margin.left - this.margin.right;
		this.height = height - this.margin.top - this.margin.bottom;
    
		this.scaleX = d3.scaleLinear().domain([0,d3.max(this.data, d => d[1])]).range([0,this.width]);
		this.scaleY = this.getScaleY();
    
		this.svg = this.container
			.append("g")
			.attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");
      
		this.svg
			.append("text")
			.text(title)
			.attr("x", this.scaleX(0))
			.attr("y", -7)
			.attr("style", "font-size: 14px; font-weight: 600")
			.attr("text-anchor", "middle");
        
		let g = this.svg
			.selectAll("g")
			.data(this.data)
			.enter()
			.append("g")
			.attr("transform", d => `translate(0,${this.scaleY(d[0])})`)
			.attr("opacity", d => this.bandOpacity(d))
			.attr("class", ".bar");

		g.append("rect")
			.attr("x", 0)
			.attr("fill", d => this.color(d))
			.attr("height", BAR_HEIGHT)
			.attr("y", d => (this.scaleY.bandwidth() - BAR_HEIGHT) / 2)
			.attr("width", d => this.bandWidth(d));

		g.append("rect")
			.attr("fill", d =>this.color(d, 1))
			.attr("height", 10)
			.attr("width", 3)
			.attr("y", d => (this.scaleY.bandwidth() - 10) / 2)
			.attr("x", d => this.bandWidth(d));
            
		g.append("text")
			.attr("text-anchor", "end")
			.attr("alignment-baseline", "middle")
			.text(d => d[0])
			.attr("y", d => (this.scaleY.bandwidth()) / 2 + 1)
			.attr("x", -8)
			.attr("style", "font-size: 13px;");
            
		g.append("text")
			.attr("text-anchor", "start")
			.attr("alignment-baseline", "middle")
			.text(d => d[1])
			.attr("y", d => (this.scaleY.bandwidth()) / 2 + 1)
			.attr("x", d => this.bandWidth(d) + 8)
			.attr("style", "font-size: 13px;");
      
		this.origin = this.svg.append("line")
			.attr("class", "y")
			.attr("x1", this.scaleX(0))
			.attr("x2", this.scaleX(0))
			.attr("y1", 0)
			.attr("y2", this.height)
			.attr("stroke", "#999")
			.attr("stroke-width", 1)
			.attr("opacity", this.lineOpacity());
	}
  
	getScaleY () {
		return d3.scaleBand()
			.domain(this.data.map(d => d[0]))
			.range([0, this.height])
			.padding(0.2);
	}
  
	lineOpacity () {
		return 1;
	}
  
	bandOpacity (d) {
		return 1;
	}
  
	color (d, darker = 0) {
		if (d[2]) {
			return d3.color(d[2]).darker(darker);
		}
		return d3.color("#b8b8b8").darker(darker);
	}

	bandWidth (d) {
		return Math.abs(this.scaleX(d[1]));
	}
}

export { Graph };
